<template>
    <div style="position:relative;">
        
        <div class="article-container">
          <div class="article-main-container">
                <div class="col-xl-7 col-6 px-0 d-flex flex-column"> 
                    <a class="go-shop-link ml-2" @click="goTo('/Shop')"> Revenir à la boutique</a>
                    <div :style="{'height' : width_image  +'px'}" class="images-select-container">
                        <div>
                            <div class="images-select-thumbnails">
                          
                            <div  v-for="(url, index) in article.article_images" class="img-thumbnail-article" :class="{'mt-0' : index == 0}" :key="index">
                                <img  @click="ThumbnailClicked" style="object-fit:cover" :data-index="index" :src="url.firebase_url" alt="" srcset="">
                            </div>
                            
                        </div>
                        </div>
                        <div ref="main_image" :style="{'height' : width_image  +'px'}" class="images-select-main">
                            <img :src="current_url" alt="" srcset="">
                        </div>
                    </div>

                </div>
              
                <div class="col-xl-5 col-6 article-data mt-3">
                    <div class="article-title">
                        <h2 v-if="article_loaded" class="article-title-text">{{article.article_name}}</h2>
                        <h2 v-else class="loading-text-dark article-title-text">Article</h2>
                        <h4 v-if="article_loaded" class="article-title-price">{{activePrice + "€"}}</h4>
                        <h4 v-else class=" loading-text article-title-price">article</h4>
                    </div>

                    <p v-if="article_loaded" v-html="article.article_description" class="article-description">
                        
                    </p>
                    <p v-else class="loading-text article-description">
                        néon led fait main qualité incroyable paris
                        néon led fait main qualité incroyable paris
                    </p>

                    <div class="article-variantes">
                        <div v-for="(variante, index) in filteredVariantes" :key="index" class="sim-color-item">
                            <div class="dot"  @click="SelectVariante(index)"> <div v-for="(color,index2) in variante.colors" :key="index2" class="h-100" :style="{'background-color' : color, 'width' : 100/ variante.colors.length + '%'}"></div></div>
                            <span :class="{'variante-active' : current_variante ==index}">{{variante.color_name}}</span>
                        </div>
                      
                        
                    </div>


                    <div class="article-dimensions">
                        <span class="article-dimensions-title">Dimensions :</span>
                        <select v-if="article_loaded" class="gray-select" name="" id="" v-model="selected_size">
                            <option v-for="(size, index) in activeSizes" :key="index" :v-show="size.active" :value="size.size_name">{{size.size_name + " - " + size.width + "cm*" + size.height + "cm"}}</option>
    
                        </select>
                        <select v-else class="gray-select" name="" id="" style="min-width:150px;pointer-events:none">    
                        </select>
                    </div>
                    <div class="article-kit-container">
                        <div class="title">
                            <span>Kit d'accrochage bande adhésive (+{{articlesHandler.options.bande3M}}€) :</span>
                            <label class="switch">
                            <input v-model="kit" type="checkbox" checked>
                            <span class="slider round"></span>
                            </label>
                        </div>
                        <span class="specs">Ajoutez les bandes adhésive 3M en plus de 
                            votre kit de vis gratuit (optionnel). Pas besoin de percer vos murs.
                        </span>
                    </div>
                    <div class="article-kit-container">
                        <div class="title">
                            <span>Le variateur et sa télécommande (+{{articlesHandler.options.telecommande}}€) :</span>
                            <label class="switch">
                            <input v-model="telecommande" type="checkbox">
                            <span class="slider round"></span>
                            </label>
                        </div>
                        <span class="specs">Pour modifier l'intensité lumineuse et faire clignoter votre néon.  
                        </span>
                    </div>
                    

                    <button :class="{'button-disabled' : !article_loaded}" class="article-panier-button" @click="AddArticleToPanier">Ajouter au panier</button>
                    <div class="icons">
           <div class="icons-item" >
               <img src="../assets/imgs/main.png" alt="ICON" srcset="">
               <span class="mt-2"><b>Fait à la main</b></span>
               <span>par nos soins</span>
           </div>
           <div class="icons-item">
               <img src="../assets/imgs/transport.png" alt="ICON" srcset="">
               <span class="mt-2"><b>Livraison gratuite</b></span>
               <span>dès 45€ d'achat</span>
           </div>
           <div class="icons-item">
               <img src="../assets/imgs/paiement.png" alt="ICON" srcset="">
                <span class="mt-2"><b>Paiement</b></span>
               <span>Simple et sécurisé</span>
           </div>
       </div>
                    
                </div>
        </div>
  
        <div class="article-info-container">
            <div ref="abc" :style="{'max-height' : ShowDescTop}" class="article-info-wrapper">
                <div class="article-info-item" style="background-color:#FFFFCC">
                <span>Description</span>
                <button class="scaleanim" data-index="0" @click="ToggleDesc">{{show_desc[0] ? "-" : "+"}}</button>
            </div>
                <div class="article-info-content">
                    <p>
                       Votre luminaire néon LED est livré avec :<br>

                        -Kit de fixation pour accroche mural OU kit d’accroche bande adhésives mural 3M (si option choisi)<br>
                        -Alimentation 12V (prise secteur classique)<br>
                        -Paire de gants et microfibre<br>
                        -Une télécommande et un variateur (si option choisi)<br>
                        


                        Fabrication : Assemblage fait à la main<br>

                        Matériaux : Neon flexible, verre acrylique<br><br>



                        
                        
                    </p>
                </div>
            </div>
            <div ref="def" :style="{'max-height' : ShowDescTop1}" class="article-info-wrapper">
                <div class="article-info-item" style="background-color:#FFD3E7">
                <span>Livraison & Garantie</span>
                <button class="scaleanim" data-index="1" @click="ToggleDesc">{{show_desc[1] ? "-" : "+"}}</button>
            </div>
                <div class="article-info-content">
                    <p>
                       
                    -Votre luminaire néon est garanti 1 an. <br><br>

                    -La livraison en France métropolitaine, Suisse et Belgique est offerte.<br><br>

                   -Vous recevrez votre néon dans un délai de 3 semaines à compter de la date de réception de votre paiement. Chaque création est faites sur-mesure et entièrement a la main. Il y a donc un temps de production.<br><br>

                    -Si l’option est disponible vous avez la possibilité de passez une commande express (> 7jours). 

 
                    </p>
                </div>
            </div>
            <div ref="ghi" :style="{'max-height' : ShowDescTop2}" class="article-info-wrapper">
                 <div class="article-info-item" style="background-color:#D4FFE9">
                <span>Installation</span>
                <button class="scaleanim" data-index="2" @click="ToggleDesc">{{show_desc[2] ? "-" : "+"}}</button>
            </div>
                <div class="article-info-content">
                    <p>
                       Durée moyenne : 5min <br><br>

                        L’installation est très simple. Clous, vis, bandes 3M sont suffisants grâce au support en acrylique pré-percé. Le plus dur sera de choisir l’emplacement idéal ! <br>

                        Vous pouvez également utiliser des filins métalliques (fournis sur demande) pour le suspendre dans une vitrine par exemple. <br>

                        Pensez à installer votre néon non loin d’une prise de courant. 


 
                    </p>
                </div>
            </div>
            <div ref="klm" :style="{'max-height' : ShowDescTop3}" class="article-info-wrapper">
                <div class="article-info-item" style="background-color:#E1F6FF">
                <span>Caractéristiques techniques</span>
                <button class="scaleanim" data-index="3" @click="ToggleDesc">{{show_desc[3] ? "-" : "+"}}</button>
            </div>
                <div class="article-info-content">
                    <p>
                       Longueur câble néon : 2m <br>

                        Longueur câble transformateur : 1,5m<br>

                        Transformateur alimentation : 12V-3/4/5/6A en fonction de la longueur de Led de votre néon<br>

                        Consommation énergétiques (en watts) : entre 5 et 10 watts/mètre en fonction de la longueur de Led de votre néon
 
                    </p>
                </div>
            </div>
            
           
            
        </div>
          </div>

          <mini-modal ref="logger">
              <div class="article-modal-content">
                <span>Votre article a été ajouté au Panier !</span>
                <div><button @click="HideLoggerModal" class="article-panier-button mr-2" >Continuer mes achats</button><button @click="GoToPanier" class="article-panier-button" >Voir mon panier</button></div>

              </div>
          </mini-modal>
    </div>
</template>

<script>
import {Article} from "../components/renderless/ArticlesHandler"
import MiniModal from "../components/MiniModal.vue"
import Vue from "vue"
export default {
    name: 'Article',
    components: {
        MiniModal,
        
    },

    data()
    {
        return {
            width_image : 0,
            selected_size : 'XS',
            articlesHandler : this.$articlesHandler,
            article : new Article(),
            current_url : "",
            telecommande : false, 
            kit : false,
            article_loaded : false,
            current_variante : 0,
            show_desc : [false, false, false , false],
            metas : [{"id":"1001-feuilles","desc":"Et avec ceci ?","title":"1001 feuilles"},{"id":"alain-melon","desc":"Pour une fois que vous pouvez avoir le melon.","title":"Alain Melon"},{"id":"alive","desc":"120 BPM","title":"Alive"},{"id":"amoureux","desc":"Fini le dîner aux chandelles, place aux lueurs du néon.","title":"Amoureux"},{"id":"apolloled","desc":"Paré au lancement dans 3,2,1 !","title":"ApolloLed"},{"id":"arc-en-ciel","desc":"Rêve ta vie en couleur, \nC'est le secret du bonheur","title":"Arc en ciel"},{"id":"belle-baleine","desc":"Une baleine qui plonge retrouver les profondeurs des mers.","title":"Belle Baleine"},{"id":"blouge","desc":"Serrez-lui la pince ! ","title":"Blouge"},{"id":"coucou","desc":"Donnez des ailes à votre mur !","title":"Coucou"},{"id":"cup-cake","desc":"Gourmand pour les yeux.","title":"Cup Cake"},{"id":"dinoled","desc":"Dino, un gentil monstre ","title":"Dinoled"},{"id":"etoile-filante","desc":"Vite, faites un vœux !","title":"Étoile filante"},{"id":"fanny","desc":"11-0 ! Embrassez Fanny !","title":"Fanny"},{"id":"feuille-de-monstera","desc":"Enfin une plante que vous n'aurez pas à arroser. ","title":"Feuille de Monstera"},{"id":"flamant-des-caraibes","desc":"Son joli plumage néon lui donne un air magique...","title":"Flamant des Caraïbes"},{"id":"flash","desc":"Quand vient la foudre vient l'éclair.","title":"Flash"},{"id":"france-98","desc":"And I've got all my love to give and I'll survive.\nI will survive, hey, hey !","title":"France 98"},{"id":"go-goldorak","desc":"Toi, le Prince de l'espace Chevalier à la rose...","title":"Go Goldorak"},{"id":"help-","desc":"Sauvez votre intérieur avec un nouveau décor !","title":"Help !"},{"id":"la-vie-est-belle","desc":"Tant pis on n'est pas nés sous la même étoile.","title":"La vie est belle"},{"id":"lamour","desc":"A la lueur des années folles.\nTypographie inspirée du \"Great Gatsby\".\n","title":"L'amour"},{"id":"lavatar-de-la-mer","desc":"On dit de lui que son grand cœur et sa gentillesse ramènent à bon port les navires perdus dans les tempêtes.","title":"L'avatar de la mer"},{"id":"licorne-des-neiges","desc":"Tagada-tagada-tadaga","title":"Licorne des neiges"},{"id":"made-in-normandie","desc":"Calva connection","title":"Made in Normandie"},{"id":"petit-coeur","desc":"Vois avec ton cœur.","title":"Petit coeur"},{"id":"petit-nuage","desc":"Il n'est point de bonheur sans nuage.","title":"Petit nuage"},{"id":"porcelaine","desc":"L'unique cochon de Bayeux.\n","title":"Porce-laine"},{"id":"puzzled","desc":"Commencez votre puzzle et combinez les couleurs !","title":"Puzzle(d)"},{"id":"renard-chenapan","desc":"🦊 Renard chenapan, chacripouille, sacré coquin 🦊","title":"Renard chenapan"},{"id":"saturne","desc":"Offrez-vous un voyage pour la sixième planète du système solaire...","title":"Saturne"},{"id":"super-size-cur","desc":"Sous hypnose...","title":"Super Size Cœur"},{"id":"sweet","desc":"Sweet life, sweet neon...","title":"Sweet"},{"id":"tango-tanga","desc":"Dansez le tango sous la lumière d'un tanga.","title":"Tango Tanga"},{"id":"venus","desc":"Venus callipyge 2.0","title":"Venus"},{"id":"very-hotdog","desc":"Avec ou sans moutarde ?","title":"Very Hot-Dog"},{"id":"watermelon","desc":"Un cucurbitacée de qualité","title":"Watermelon"}],
        }
    },

    metaInfo() {
      const id = this.$route.params.article_id
      let name = "";
      let desc = "";
      for(let i = 0; i < this.metas.length; i++)
      {
        if(this.metas[i].id === id)
        {
          name = this.metas[i].title;
          desc = this.metas[i].desc;
        }
      }
        return {
            title : this.article.article_name,
            meta : [
                {name : 'description', content : desc},
                 { property: 'og:title', content: name},
                { property: 'og:site_name', content: 'Neon Bloom Paris'},
                {property: 'og:type', content: 'website'},    
                {name: 'robots', content: 'index,follow'},
            ]
        }
    }
     ,
    computed : {

        activeSizes: function() {
       return this.article.article_sizes.filter(function(u) {
         return u.active
        })
        },

        ShowDescTop() {
            
            if(this.show_desc[0]){
                
           
            return (this.$refs.abc.scrollHeight + 'px')}
            return "70px";

        },
        ShowDescTop1() {
            
            if(this.show_desc[1]){
                
        
            return (this.$refs.def.scrollHeight + 'px')}
            return "70px";

        },
        ShowDescTop2() {
            
            if(this.show_desc[2]){
                
             
            return (this.$refs.ghi.scrollHeight + 'px')}
            return "70px";

        },
        ShowDescTop3() {
            
            if(this.show_desc[3]){
                
          
            return (this.$refs.klm.scrollHeight + 'px')}
            return "70px";

        },

    

        
   

        filteredVariantes()
        {
    
            return this.article.article_colors.filter(variante => variante.color_name != "");
        },


        hasVariantes()
        {
            return(this.article.article_colors.length != 1);
        },
        
        activeStock()
        {
             for(let i = 0; i < 4;i++)
            {
                if(this.article.article_sizes[i].size_name == this.selected_size)
                {
               
                   return this.article.article_sizes[i].stock;
                }
            }
            return 0;
        },

      

        activePrice() {
            for(let i = 0; i < 4;i++)
            {
                if(this.article.article_sizes[i].size_name == this.selected_size)
                {
                   
                    let a = this.article.article_sizes[i].unit_price;
                    if(this.kit)a+=this.articlesHandler.options.bande3M;
                    if(this.telecommande)a+=this.articlesHandler.options.telecommande;
                    return a.toFixed(2);
                }
            }
            return 0;
            
        }
            
        
    

    },

    methods: {

        HideLoggerModal()
        {
            this.$refs.logger.Hide();
        },

        ToggleDesc(event)
        {
            const index = parseInt(event.target.dataset.index);
        
            const val = !this.show_desc[index]
            if(window.innerWidth > 966)
            {
                if(index == 0 || index == 1)
                {
                    
                    Vue.set(this.show_desc, 0, val)
                    Vue.set(this.show_desc, 1, val)
                }
                else {
                     Vue.set(this.show_desc, 2, val)
                    Vue.set(this.show_desc, 3, val)
                }
                
            }
            else {
                Vue.set(this.show_desc, index, val)
            }
            
       
        },

           goTo : function(path)
        {
         
            
            if(path == this.$route.path)return;
            this.$router.push({path : path});
        },


        SelectVariante(index)
        {
            this.current_variante = index;
        },

        ResizeHandler()
        {
            this.$nextTick(() => {
                this.width_image = this.$refs.main_image.offsetWidth;
            })
        },
        ThumbnailClicked(event)
        {
            if(event.target.dataset.index != null)
            {
                this.current_url = this.article.article_images[event.target.dataset.index].firebase_url;
            }
        },

         linkify(text) {
            var urlRegex = new RegExp("(link\\((.*^\\))\\)){1}","g");
           
            return text.replace(urlRegex, function(url) {
        return '<a href="' + url.replace("link(","").replace(")","") + '">' + url.replace("link(","").replace(")","") + '</a>';
    });
},
        LoadArticle()
        {
            try {
                const article_id = this.$route.params.article_id;
            this.$articlesHandler.GetArticleFromId(article_id).then((article) => {
                this.article = article;
               for(let i = 0; i< 4; i++)
               {
                   if(this.article.article_sizes[i].active)
                   {
                       this.selected_size = this.article.article_sizes[i].size_name;
                       break;
                   }
               }
               this.current_url = article.article_images[0].firebase_url;
               
             
               this.article_loaded = true;
            })
            } catch (err){
                console.log('Erreur lors du chargement');
            }

        }, 

        AddArticleToPanier()
        {
            let size = 0;
            switch(this.selected_size)
            {
                case "XS" : size = 0;break;
                case "S" : size = 1;break;
                case "M" : size = 2;break;
                case "L" : size = 3;break;
            }
            let couleur = null
            if(this.article.article_colors.length != 0)
            {
                couleur = this.article.article_colors[this.current_variante].ExportToJSON()
            }
            
            const params = {size : size, "telecommande" : this.telecommande, "bande3M" : this.kit, "variante" : couleur == null ? "Default" : couleur.color_id }
            this.$panierHandler.AddArticleToPanier(this.article,params);
            this.$refs.logger.Reveal('Article ajouté', "", 460,"#16a085");

        },
        GoToPanier()
        {
            
            this.$router.push('/Panier');
        }
    },
    created() {
        window.addEventListener("resize", this.ResizeHandler);
        this.LoadArticle();
    },
    destroyed() {
        window.removeEventListener("resize", this.ResizeHandler);
    },
    mounted() {
         this.width_image = this.$refs.main_image.offsetWidth;
         window.scrollTo(0,0);



         
         
    }
}
</script>

<style scoped>

.article-info-content {
    padding : 1rem;
    width : 100%;
}

.article-info-content > p {
   
    white-space: pre-wrap;
    text-align :justify

}


.article-info-wrapper {
    overflow-y: hidden;
    transition-duration : 0.2s;
}
.icons {
    width : 100%;
    padding : 1rem;
    display : flex;
    justify-content: center;
    align-items: flex-start;
    align-self: center;
    margin-top: 1rem;
}
.icons-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width : 150px;
    margin : 0 0.5rem;

}

.icons-item > span {
    font-size : 12px;
}

.icons-item > img {
    width : 60px;
    height : 60px;
}

.go-shop-link {
    width : 100%;
    font-size : 14px;
    text-align : left;
    cursor : pointer;
}

.article-variantes {
    display : flex; 
    align-items : center;
    justify-content : flex-start;
    width : 100%;
    flex-wrap : wrap;
}

.dot:hover {
  transform: scale(1.05);
}

.dot {
    display: flex;
    overflow: hidden;
  margin:0.5rem auto;
  border-radius: 30px;
  width: 40px;
  height:40px;
  background-color: salmon;
  box-shadow: 3px 3px 2px 0px rgba(133, 103, 103, 0.42);
  transition-duration: 0.2s;
  cursor: pointer;
  pointer-events: all;

}

.sim-color-item {
  margin : 0 0.5rem;
  min-width : 53px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family : 'Montserrat', sans-serif;
  margin-bottom: 1rem;
}

.sim-color-item > span {
  margin-top : 0.25rem;
  font-size : 14px;
  user-select: none;
  transition-duration: 0.2s;
  color : #707070;
}

.variante-active {
    font-weight : bold;
    color : black;
}

.img-thumbnail-article{
    width:110px;
    height:110px;
}


@media(max-width:450px)
{
    .article-info-item > span {
        font-size : 16px!important;
    }
}


@media(max-width: 540px)
{
    .title {
        width : 100%!important;
        flex-direction: column!important;
        align-items: center;
        font-size: 15rem;
        
    }

    .article-description 
    {
        text-align: center!important;
    }

    .article-main-container {
        padding : 0!important;
    }

    .article-dimensions {
        flex-direction: column!important;
        align-items: center!important;
    }

    .title > span {
        margin-right : 0!important;
        white-space:normal!important;
    }

    .specs {
        font-size : 14px!important;
        text-align: center!important;
    }
}

@media(max-width : 550px)
{
    .icons {
        flex-direction: column;
        align-items: center!important;
    }

    .icons-item {
        margin : 0.5rem 0!important;
    }

    .article-info-container {
        margin-top: 1rem!important;
    }
}

@media(max-width : 966px)
{
    .go-shop-link {
        text-align: center!important;
    }
    .article-main-container {
        flex-direction: column!important;
    }

    .images-select-container {
        max-width: 400px!important;
    }

    .article-variantes {
        align-items: center!important;
       justify-content: center!important;
    }

    .article-main-container > div {
        width : 100%!important;
        max-width: 100%!important;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .article-info-container {
        display: flex!important;
        width: 100%;
        flex-direction: column;

    }

    .images-select-main {
        max-width : 400px!important;
        max-height: 400px!important;
    }
}

@media (max-width : 1100px)
{
    .images-select-container {
        flex-direction : column-reverse;
        height: unset!important;
    }
    .images-select-main {
        overflow: auto!important;
    }

    

    

    .images-select-thumbnails {
    display: flex;
    margin-top: 0.25rem!important;
    flex-direction: row;
    width: 100%!important;
    align-items: flex-start;
    justify-content: center;
    padding: 0 0!important;
    direction:ltr!important;
    overflow-y: auto!important;
    overflow-x: auto ;
    }

    .img-thumbnail-article {
        margin-top: 0!important;
        margin-right : 0.1rem!important;
    }
}

.article-modal-content {
    padding: 1rem;
    width: 100%;
    display : flex;
    flex-direction: column;
    color : black;
    align-items : center;
    justify-content : center;
}

.button-disabled {
    background-color: grey!important;
    border: 1px solid gray!important;
    color: lightgray!important;
    pointer-events: none;
}

.loading-text {
    border-radius: 4px;
    background: linear-gradient(270deg, #8a8a8a, #d1d1d1);
    background-size: 400% 400%;
    color : transparent!important;
    pointer-events: none;
    user-select: none;
    animation: load 3s ease infinite;
}

.loading-text-dark {
    border-radius: 4px;
    background: linear-gradient(270deg, #8a8a8a, #d1d1d1);
    background-size: 400% 400%;
    color : transparent!important;
    pointer-events: none;
    user-select: none;
    animation: load 3s ease infinite;
}


@keyframes load {
    0%{background-position:0% 50%}
    50%{background-position:100% 50%}
    100%{background-position:0% 50%}
}


/*IMAGE SELECT */

.images-select-container {
    width: 95%;
    padding :0.25rem;
    
    height :70%;
    display: flex;

}



.images-select-thumbnails {
    width : 120px;
    min-width : 120px;
    overflow-y: auto ;
    direction:rtl;
    padding-left: 0.25rem;
    margin-right: 0.5rem;
    height: 100%;

    
}

/* width */
.images-select-thumbnails::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
.images-select-thumbnails::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
.images-select-thumbnails::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
}

/* Handle on hover */
.images-select-thumbnails::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.images-select-thumbnails > div {
    
    aspect-ratio: 1/1;
    object-fit: cover;
    cursor: pointer;
    margin: 0.25rem 0;
    display: flex;
    border : 1px solid gray
}

.images-select-thumbnails > div > img {
    object-fit: cover;
    width: 100%;
}

.images-select-main {
    
    cursor: pointer;
    display: flex;
    object-fit : contain;
    flex-grow: 1;
    aspect-ratio: 1/1;
    overflow: hidden;
    max-width: 600px;
    border : 1px solid gray;
}

.images-select-main > img {

    width: 100%;
    object-fit : cover
}




/*ARTICLE TEXT */

.article-container {
    
    font-family: 'Montserrat', sans-serif;
    padding-top: 6rem;
    width: 100%;
    color: black;
    display: flex;
    align-items: center;
    flex-direction: column;
    position: relative;

}

.article-main-container {
    padding: 0 1rem;
    display: flex;
    flex-direction: row;
    max-width : 1500px;
    width: 100%;
}

.article-data {
    display: flex;
    flex-direction : column;
    align-items: flex-start;
}

.article-title {
    display : inherit;
    flex-direction : column;
    align-items: flex-start;
}

.article-title-text {
    font-size: 35px;
    font-weight: 800;
    color : "#342B59";
}

.article-title-price {
    color : var(--amaranth);
    font-size : 20px;
}

.article-stock {
    margin-top: 0.5rem;
    display: inherit;
    flex-direction: row;
    font-size: 16px;
    justify-content: center;
}

.article-stock > span {
    display: flex;
    align-items: center;
}

.article-stock-data {
    width : 30px;
    height : 30px;
    margin : 0px 5px;
    margin-bottom: 2px;
    font-size : 16px;
    color : white;
    font-weight: 700;
    background-color : var(--pretty-green);
    border-radius : 30px;
    display : flex;
    justify-content: center;
    align-items: center;
}

.article-description {
    display : flex;
    align-items: flex-start;
    text-align: left;
    margin-top: 1.75rem;
    min-height : 30px;
}

.article-dimensions {
    margin-top : 1rem;
    display : flex;
    justify-content: center;
}

.article-dimensions-title {
    display: inherit;
    align-items: center;
    margin-right: 1rem;
}

.gray-select {
    background-color : #F6F6F6;
    border-radius : 7px;
    border: none;
    color:black;
    outline : none;
    padding : 0.75rem 1rem;
}

.article-kit-container {
    margin-top : 2rem;
    display: inherit;
    flex-direction: column;
    align-items: flex-start;
}

.title {
    width: 457px;
    display: flex;
    font-size: 17px;
    flex-direction : row;
    

}

.title > span {
    margin-right: auto;
    display: flex;
    white-space: nowrap;
    align-items : center;
}

.specs {
    margin-top: 0.25rem;
    color : darkslategrey;
    text-align: left;
    font-size: 14px;

}

.slide-button {
    width : 53px;
    height : 29px;
    background-color : var(--pretty-green);
    border-radius: 20px;
}

.article-panier-button {
    color : white;
    align-self : center;
    font-family: 'DIN', sans-serif;
    font-size: 1.3rem;
    font-weight : 400;
    display : flex;
    outline : none;
    align-items : center;
    justify-content: center;
    background-color : var(--amaranth);
    border : 1px solid var(--amaranth);
    width : 210px;
    transition-duration: 0.2s;
    height : 50px;
    margin-top: 2rem;
}

.article-panier-button:hover {
    background-color: white;
    color : var(--amaranth);

}


/*#region SLIDER*/
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
   margin: 0;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
 
}



/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: var(--pretty-green);
}

input:focus + .slider {
  box-shadow: 0 0 1px var(--pretty-green);
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

/*#endregion*/


.article-info-container {
    display: grid;
    width: 100%;
    margin-top : 2rem;
    grid-template-columns: 50% 50%;
}

.article-info-item {
    width: 100%;
    height: 70px;
    display: flex;
    text-align : left;
    padding: 0 0.75rem;
    align-items: center;
}

.article-info-item > span {
    font-size: 1.1rem;
    margin-left : 2rem;
}

.article-info-item > button {
    border : none;
    outline : none;
    margin-left : auto;
    font-size: 1.5rem;
    color : #707070;
    font-weight: bold;
    background-color : unset

}

</style>